<template>
    <v-card-text>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="6"
                >
                    <v-text-field
                        v-model="$store.state.cablesEditedItem.REFERENCE"
                        label="REFERENCE (*)"
                        :rules="[() => !!$store.state.cablesEditedItem.REFERENCE]"
                        :error-messages="$store.state.errorMessages"
                        required
                   ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.cablesEditedItem.DESC_NL"
                        label="DESC_NL (*)"
                        :rules="[() => !!$store.state.cablesEditedItem.DESC_NL]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.cablesEditedItem.DESC_FR"
                        label="DESC_FR (*)"
                        :rules="[() => !!$store.state.cablesEditedItem.DESC_FR]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="4"
                    md="4"
                >
                    <v-text-field
                        v-model="$store.state.cablesEditedItem.TYPE"
                        label="TYPE (*)"
                        :rules="[() => !!$store.state.cablesEditedItem.TYPE]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="2"
                    md="2"
                >
                    <v-text-field
                        v-model="$store.state.cablesEditedItem.SECTION"
                        label="SECTION (mm²) (*)"
                        :rules="[() => !!$store.state.cablesEditedItem.SECTION]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.cablesEditedItem.LENGTH"
                        label="LENGTH (m) (*)"
                        :rules="[() => !!$store.state.cablesEditedItem.LENGTH]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="4"
                    md="4"
                >
                    <v-text-field
                        v-model="$store.state.cablesEditedItem.CONNECTORS"
                        label="CONNECTORS"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
	export default {
		name: "FormulaireCables",
		data: function () {
			return {
            }
        }
    }
</script>
